





























































helpers = require('../../helpers.coffee')

view_model = {
  props: ['task', 'options', 'origem', 'type', 'prop_tooltip_placement']

  components:
    confirm: require('../shared/modals/confirm')

  data: ->
    current_user: Session.current_user
    tooltip_text: @task.comment
    tooltip_placement: 'right'
    element_options:
      show_date: false
      show_contact: true
      show_comment: true
      icon_position: 'text' # 'item' available
      padding: 'sm' # 'lg' available

  computed:
    total_open: ->
      @task.contact?.interactions_with_current_flow?.total_open || "-"

    total_delivery: ->
      @task.contact?.interactions_with_current_flow?.total_delivery || "-"

    confirmTaskId: ->
      "confirm-task-done-#{@task.id}"

    showConfirmationModal: ->
      @task.service == 'ManualTasksServices::Email'

    showComposeMeeting: ->
      @task.service == 'ManualTasksServices::Meeting'

  methods:
    iconClass: ->
      switch @task.service
        when 'ManualTasksServices::Email' then 'email-send-icon'
        when 'ManualTasksServices::Phonecall' then 'hidden'
        when 'ManualTasksServices::Linkedin' then 'linkedin-icon'
        when 'ManualTasksServices::Social' then 'social-icon'
        when 'ManualTasksServices::Meeting' then 'meeting-icon'
        else 'email-send-icon'

  watch:
    task: (new_value, old_value) ->
      @$refs.element_id.setAttribute('data-original-title', new_value.comment)

  mounted: ->
    Tooltip.initialize()

  created: ->
    @tooltip_placement = @prop_tooltip_placement if @prop_tooltip_placement?
    @tooltip_placement = "left" if (@type?.tasks_status == "overdue" || @type?.tasks_status == "future")

    EventsBus.$on 'voip-call-complete', @registerVoipCall
    @tasks_resources = new TasksResource
    @mergeDefaultOptions()
}

exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/list_item.vue